import React from 'react';
import logger from '../utils/logger';
import Analytics from '../utils/analytics';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // Log the error using our new observability utility
    logger.error('React Component Error:', error, errorInfo);
    Analytics.trackError('React DOM', error?.message || 'Unknown Crash', true);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="empty-state ui-empty-state">
          <h2>Algo não saiu como esperado.</h2>
          <p>Tivemos um problema ao exibir esta tela. Nossa equipe já foi notificada silenciosamente.</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Tentar Novamente
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
